import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Hero } from '../components/Hero';
import { ClientLogos } from '../components/ClientLogos';
import { About } from '../components/About';
import { Specialties } from '../components/Specialties';
import { WhyForax } from '../components/WhyForax';
import { ProjectsGallery } from '../components/ProjectsGallery';
import { FinalCTA } from '../components/FinalCTA';
export function LandingPage() {
  return <main className="min-h-screen w-full bg-white font-sans text-gray-900 selection:bg-blue-600 selection:text-white" data-id="element-790">
      <Header data-id="element-791" />

      <div id="home" data-id="element-792">
        <Hero data-id="element-793" />
      </div>

      <ClientLogos data-id="element-794" />

      <div id="about" data-id="element-795">
        <About data-id="element-796" />
      </div>

      <Specialties data-id="element-797" />
      <WhyForax data-id="element-798" />

      <div id="projects" data-id="element-799">
        <ProjectsGallery data-id="element-800" />
      </div>

      <div id="contact" data-id="element-801">
        <FinalCTA data-id="element-802" />
      </div>

      <Footer data-id="element-803" />
    </main>;
}